import { useMemo } from 'react';
import { useGetConnectionInsightsQuery } from '../../../redux/api/fymAPI';
import { ConnectionInsight } from '../../../redux/api/fymAPI.types';

interface UseConnectionInsightsProps {
  accountId: number;
}

/**
 * The follower numbers behind the connection cards, keyed by service.
 *
 * A service is in the answer only when a profile url of ours is being read
 * daily, so most accounts get a short map or an empty one. The error is
 * swallowed on purpose: this is an addition to a card that already works
 * without it, and an outage has to leave the strip exactly as it was.
 */
export function useConnectionInsights({ accountId }: UseConnectionInsightsProps): Record<string, ConnectionInsight> {
  const { data } = useGetConnectionInsightsQuery({ accountId });

  return useMemo(() => {
    const byService: Record<string, ConnectionInsight> = {};
    (data?.insights ?? []).forEach((insight) => {
      byService[insight.integrationType] = insight;
    });
    return byService;
  }, [data]);
}
